// frontend/apps/demo/piwa-portfolio/src/theme/theme.provider.tsx
import React, { createContext, useContext, ReactNode } from 'react';
import { prehistorikTheme } from './prehistorik-theme';

// Export the theme type from our theme definition
export type PrehistorikTheme = typeof prehistorikTheme;

const ThemeContext = createContext<PrehistorikTheme>(prehistorikTheme);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Keep backward compatibility alias
export const useRetroTheme = useTheme;

interface ThemeProviderProps {
  children: ReactNode;
  theme?: Partial<PrehistorikTheme>;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ 
  children, 
  theme = {} 
}) => {
  // Deep merge the theme with defaults
  const mergedTheme = {
    ...prehistorikTheme,
    ...theme,
    colors: { ...prehistorikTheme.colors, ...theme.colors },
    fonts: { ...prehistorikTheme.fonts, ...theme.fonts },
    fontSizes: { ...prehistorikTheme.fontSizes, ...theme.fontSizes },
    spacing: { ...prehistorikTheme.spacing, ...theme.spacing },
    radius: { ...prehistorikTheme.radius, ...theme.radius },
    shadows: { ...prehistorikTheme.shadows, ...theme.shadows },
    borders: { ...prehistorikTheme.borders, ...theme.borders },
    transitions: { ...prehistorikTheme.transitions, ...theme.transitions },
    zIndex: { ...prehistorikTheme.zIndex, ...theme.zIndex },
    breakpoints: { ...prehistorikTheme.breakpoints, ...theme.breakpoints },
    effects: { ...prehistorikTheme.effects, ...theme.effects },
    game: { ...prehistorikTheme.game, ...theme.game },
  } as PrehistorikTheme;

  return (
    <ThemeContext.Provider value={mergedTheme}>
      {children}
    </ThemeContext.Provider>
  );
};